<template>
  <div class="ts-px-2 ts-border ts-rounded-md ts-bg-gray-100 ts-pb-3">
    <div class="table-gride ts-sticky ts-top-0 ts-z-10 ts-bg-gray-100 ts-pt-2">
      <div class="ts-font-semibold ts-border-b ts-px-2 ts-py-1 ts-uppercase">
        {{ $t('paymentNotice.feeType') }}
      </div>
      <div class="ts-font-semibold ts-border-b ts-px-2 ts-py-1 ts-uppercase">
        {{ $t('paymentNotice.feeName') }}
      </div>
      <div class="ts-font-semibold ts-border-b ts-px-2 ts-py-1 ts-uppercase">
        {{ $t('paymentNotice.description') }}
      </div>
      <div class="ts-font-semibold ts-border-b ts-px-2 ts-py-1 ts-uppercase">
        {{ $t('paymentNotice.startDate') }}
      </div>
      <div class="ts-font-semibold ts-border-b ts-px-2 ts-py-1 ts-uppercase">
        {{ $t('paymentNotice.endDate') }}
      </div>
      <div class="ts-font-semibold ts-border-b ts-px-2 ts-py-1 ts-uppercase">
        {{ $t('paymentNotice.qty') }}
      </div>
      <div class="ts-font-semibold ts-border-b ts-px-2 ts-py-1 ts-uppercase">
        {{ $t('paymentNotice.fee') }}
      </div>
      <div class="ts-font-semibold ts-border-b ts-px-2 ts-py-1 ts-uppercase">
        {{ $t('paymentNotice.discountType') }}
      </div>
      <div class="ts-font-semibold ts-border-b ts-px-2 ts-py-1 ts-uppercase">
        {{ $t('paymentNotice.discount') }}
      </div>
      <div class="ts-font-semibold ts-border-b ts-px-2 ts-py-1 ts-uppercase">
        {{ $t('paymentNotice.vat') }} %
      </div>
      <div class="ts-font-semibold ts-border-b ts-px-2 ts-py-1 ts-uppercase">
        {{ $t('paymentNotice.amount') }}
      </div>
    </div>
    <div
      class="table-gride ts-relative"
      v-for="(item, index) in model.inv_detail_list"
      :key="index"
    >
      <div class="ts-border-b ts-px-2 ts-py-1">
        <a-select
          v-model="item.fee_type_id"
          :disabled="notAvailable"
          style="width: 100%"
          :options="feeTypeList"
          showSearch
          optionFilterProp="children"
          :filterOption="filterOption"
          @change="onFeeTypeChange(item)"
        />
        <div
          class="validate"
          v-if="errors.has('inv_detail_list.' + index + '.fee_type_id')"
        >
          {{ errors.first('inv_detail_list.' + index + '.fee_type_id') }}
        </div>
      </div>
      <div class="ts-border-b ts-px-2 ts-py-1">
        <a-select
          v-model="item.fee_setup_id"
          showSearch
          style="max-width: 230px; width: 100%;"
          :options="feeSetupList(item)"
          optionFilterProp="children"
          :filterOption="filterOption"
          @change="(_, options) => onFeeChange(options, item)"
        />
        <div
          class="validate"
          v-if="errors.has('inv_detail_list.' + index + '.fee_setup_id')"
        >
          {{ errors.first('inv_detail_list.' + index + '.fee_setup_id') }}
        </div>
      </div>
      <div class="ts-border-b ts-px-2 ts-py-1">
        <input
          type="text"
          v-model="item.fee_description"
          class="form-control"
        />
      </div>
      <div class="ts-border-b ts-px-2 ts-py-1">
        <a-date-picker
          v-model="item.fee_start_date"
          placeholder="Date To"
          valueFormat="DD-MM-YYYY"
          format="DD-MM-YYYY"
        ></a-date-picker>
      </div>
      <div class="ts-border-b ts-px-2 ts-py-1">
        <a-date-picker
          v-model="item.fee_end_date"
          placeholder="Date To"
          valueFormat="DD-MM-YYYY"
          format="DD-MM-YYYY"
        ></a-date-picker>
      </div>
      <div class="ts-border-b ts-px-2 ts-py-1">
        <input
          type="number"
          class="form-control"
          min="1"
          v-model="item.quantity"
          @input="calculate(item)"
        />
        <div
          class="validate"
          v-if="errors.has('inv_detail_list.' + index + '.quantity')"
        >
          {{ errors.first('inv_detail_list.' + index + '.quantity') }}
        </div>
      </div>
      <div class="ts-border-b ts-px-2 ts-py-1">
        <input
          type="number"
          readonly
          class="form-control"
          v-model="item.fee_amount"
        />
      </div>
      <div class="ts-border-b ts-px-2 ts-py-1">
        <a-select
          v-model="item.discount_type"
          style="width: 100%"
          :options="[{ value: '$', label: '$' }, { value: '%', label: '%' }]"
          @change="calculate(item)"
        />
      </div>
      <div class="ts-border-b ts-px-2 ts-py-1">
        <input
          type="number"
          class="form-control"
          v-model="item.discount_rate"
          @input="calculate(item)"
        />
      </div>
      <div class="ts-border-b ts-px-2 ts-py-1">
        <input
          type="number"
          class="form-control"
          v-model="item.vat_rate"
          @input="calculate(item)"
        />
      </div>
      <div class="ts-border-b ts-px-2 ts-py-1">
        <input
          type="number"
          class="form-control"
          readonly
          :value="item.total_amount"
        />
      </div>
      <div
        class="ts-absolute ts-top-0 ts-right-0 ts-mt-1 ts-mr-2 icon-delete ts-hidden"
      >
        <button
          class="ts-bg-red-100 ts-h-8 ts-w-8 ts-rounded-full ts-shadow-md ts-text-red-500 hover:ts-bg-red-500 hover:ts-text-white ts-duration-200 focus:ts-outline-none"
          @click.prevent="removeRow(index)"
        >
          <i class="fas fa-trash"></i>
        </button>
      </div>
    </div>
    <div
      v-if="!hasItem"
      class="ts-h-full ts-w-full ts-flex ts-items-center ts-justify-center ts-mt-2"
    >
      <div class="ts-text-center ts-text-gray-300">
        <i class="fas fa-folder-open fa-3x"></i>
        <h1 class="ts-mt-2 ts-font-bold ts-uppercase ts-text-gray-300">
          {{ $t('noData') }}
        </h1>
      </div>
    </div>
    <button
      @click.prevent="addNewRow"
      class="ts-w-full ts-bg-blue-200 ts-mt-2 ts-p-2 ts-rounded-md focus:ts-outline-none hover:ts-bg-blue-300 hover:ts-text-white ts-duration-200"
    >
      <i class="fa fa-plus"></i>
      {{ $t('paymentNotice.moreItem') }}
    </button>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { ceil, round, sumBy, uniqBy } from 'lodash'
import moment from 'moment'
import { mapActions, mapMutations, mapState } from 'vuex'
export default {
  name: 'feeItemNameV2',
  props: ['value', 'validate'],
  data() {
    return {
      feeTypes: [],
      feeSetups: [],
      model: {},
      errors: new Errors()
    }
  },
  created() {
    this.model = this.value
  },
  mounted() {
    this.fetchFeeType()
  },
  computed: {
    ...mapState('paymentNoticeModule', ['selectedStudent', 'academicTerms']),
    hasItem() {
      if (!this.model.inv_detail_list) return false
      return this.model.inv_detail_list.length
    },
    notAvailable() {
      return !(
        (this.model.student_id != '') | null &&
        (this.model.grade_id != null) | undefined
      )
    },
    feeTypeList() {
      return this.feeTypes.map(el => ({
        value: el.fee_type_id,
        label: el.fee_type_name
      }))
    },
    feeSetupList: vm => row => {
      const excludeId = vm.model.inv_detail_list
        .filter(
          f => f.fee_setup_id !== row.fee_setup_id && f.fee_setup_id !== null
        )
        .map(e => e.fee_setup_id)
      return vm.feeSetups
        .filter(f => f.fee_type_id === row.fee_type_id)
        .filter(f => !excludeId.includes(f.fee_setup_id))
        .map(el => ({
          value: el.fee_setup_id,
          label: el.fee_name_en,
          title: el.fee_name_en,
          fee_amount: el.fee_amount,
          grade_id: el.grade_id,
          fee_name_en: el.fee_name_en
        }))
    }
  },
  methods: {
    ...mapActions('paymentNoticeModule', [
      'onGetFeeType',
      'onGetStudentFeeDetail',
      'onGetFeeSetup'
    ]),
    ...mapMutations('paymentNoticeModule', ['SET_LOADING']),
    fetchFeeType() {
      this.onGetFeeType().then(response => (this.feeTypes = response.data.data))
    },
    addNewRow() {
      this.model.inv_detail_list.push({
        fee_type_id: null,
        fee_setup_id: null,
        fee_description: null,
        quantity: 1,
        fee_amount: 0,
        discount_type: '%',
        discount_rate: 0,
        discount_amount: 0,
        total_amount: 0,
        vat_rate: 0,
        vat_amount: 0,
        amount_include_vat: 0,
        grade_id: null,
        fee_start_date: null,
        fee_end_date: null
      })
    },
    removeRow(index) {
      this.model.inv_detail_list.splice(index, 1)
      this.model.total_amount = sumBy(
        this.model.inv_detail_list,
        'total_amount'
      )
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    onFeeTypeChange(row) {
      row.fee_setup_id = null
      row.fee_amount = 0
      row.discount_type = '%'
      row.discount_rate = 0
      row.vat_rate = 0
      this.calculate(row)
      const existingFeeType = this.feeSetups.find(
        ft => ft.fee_type_id === row.fee_type_id
      )
      if (!existingFeeType) {
        this.SET_LOADING(true)
        this.onGetFeeSetup({
          grade_id: this.model.grade_id,
          fee_type_id: row.fee_type_id
        })
          .then(response => {
            this.feeSetups = uniqBy(
              [...this.feeSetups, ...response.data.data],
              'fee_setup_id'
            )
          })
          .finally(() => this.SET_LOADING(false))
      }
    },
    isDateExpired(dateString) {
      if (!dateString) return false
      // Parse DD-MM-YYYY format and compare with today
      const inputDate = moment(dateString, 'DD-MM-YYYY')
      const today = moment()

      return inputDate.isBefore(today, 'day')
    },
    onFeeChange(options, row) {
      const { fee_amount, grade_id, fee_name_en } = options.data.props
      row.fee_amount = fee_amount
      row.grade_id = grade_id
      row.fee_description = fee_name_en
      if (this.selectedStudent && row.fee_type_id === 1) {
        if (this.selectedStudent.is_till_further_notice) {
          row.discount_rate = this.selectedStudent.card_discount_rate || 0
        } else if (this.selectedStudent.discount_expiry_date) {
          if (!this.isDateExpired(this.selectedStudent.discount_expiry_date)) {
            row.discount_rate = this.selectedStudent.card_discount_rate || 0
          }
        }
      }
      this.setFeeDate(row)
      this.calculate(row)
    },
    calculate(item) {
      let price = 0
      if (item) {
        price = item.fee_amount ? item.fee_amount * item.quantity : 0
        if (item.discount_type == '%') {
          item.discount_amount = item.discount_rate
            ? price * round(item.discount_rate / 100, 4)
            : 0
        }
        if (item.discount_type == '$') {
          item.discount_amount = item.discount_rate
        }
        item.vat_amount = ((price - item.discount_amount) * item.vat_rate) / 100
        item.total_amount =
          ceil(price - item.discount_amount, 2) + item.vat_amount
        item.amount_include_vat = ceil(
          price - item.discount_amount + item.vat_amount,
          2
        )
        this.model.total_amount = sumBy(
          this.model.inv_detail_list,
          'total_amount'
        )
      } else {
        this.model.total_amount = 0
      }
    },
    setFeeDate(row) {
      if ([1,4].includes(row.fee_type_id) && this.academicTerms) {
        const findTerm = this.academicTerms.find(
          t => (t.ac_term_id = this.model.ac_term_id)
        )
        if (findTerm) {
          row.fee_start_date = findTerm.term_start
          row.fee_end_date = findTerm.term_stop
        }
      }
    }
  }
}
</script>

<style scoped>
.table-gride {
  display: grid;
  grid-template-columns: 200px 230px auto 130px 130px repeat(5, 70px) 100px;
}
.table-gride:hover .icon-delete {
  display: block;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
